import React from 'react';
import PropTypes from 'prop-types';
import {get} from './Storage';
import axios from 'axios';
import Avatar from 'material-ui/Avatar';
import NewsConfirmButton from './NewsConfirmButton';
import CircularProgress from 'material-ui/CircularProgress';
import {Card, CardHeader, CardText, CardMedia} from 'material-ui/Card';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'MGNewsComponent';

var styles = AppSettings.styles;

class News extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            text: "",
            documents: [],
            confirmButton: "",
            showLoadingNews: false,
            imgUrl: "",
            opened: false
        }
        this.handleGetNews = this.handleGetNews.bind(this);
    }

    componentDidMount() {
        this.setState({text: "", opened: false});
    }

    handleGetNews(event) {
        if (this.state.opened) {
            this.setState({
                text: "",
                confirmButton: "",
                documents: [],
                showLoadingNews: false,
                imgUrl: "",
                opened: false
            });
            this.context.realoadNews(false);
            return;
        }

        var url = this.props.news.links[0].href;

        this.setState({
            showLoadingNews: true,
            opened: true
        });
        
        if (AppSettings["env"].name == 'dev') {
            url = AppSettings['env'].urlUserBoxGetNews;
        }

        axios.get(url)
            .then(({data, status, statusText}) => {
                if (data.errors.length == 0) {
                    var text = data.text;
                    var confirmButton = "";
                    if (this.props.news.hasToBeConfirmed) {
                        confirmButton = <NewsConfirmButton newsId={data.id}/>;
                    }

                    var imgUrl = "";
                    if (data.hasFeaturedImage) {
                        imgUrl =  data.featuredImage
                    }
                    this.setState({
                        text: text,
                        documents: data.documents,
                        confirmButton: confirmButton,
                        showLoadingNews: false,
                        imgUrl:imgUrl
                    });
                }
            })

            .catch(({data, status, statusText}) => {
            });
    }
    
    renderMediaCard(){
        if(this.state.imgUrl == ""){
            return null;
        }
        else{
            return (
                <CardMedia>
                    <img src={this.state.imgUrl} />
                </CardMedia>
            )
        }
    }

    render() {
        var color = "";
        if (!this.props.news.read) {
            color = AppSettings.theme.primarycolor
        }
        var avatar = <Avatar backgroundColor={color} className="userbox-avatar" color="#fff">{this.props.news.avatar.toUpperCase()}</Avatar>;

        var documents = "";
        if (this.state.documents.length > 0) {
            var documents = this.state.documents.map(function (document, i) {
                var key = "document_" + document.id;
                return (
                    <a key={key} className="news-attachment" href={document.url}>
                        <i className="fa fa-paperclip"></i> {document.fileName}
                    </a>
                )
            });
        }

        var clip = "";
        if (this.props.news.hasAttachments) {
            clip = <i className="fa fa-paperclip"></i>;
        }
        var title = <div style={styles.pointer} onClick={this.handleGetNews}>{clip} {this.props.news.subject}</div>;
        var date  = <div style={styles.pointer} onClick={this.handleGetNews}>{this.props.news.date}</div>;
        var url = this.props.news.links[0].href;
        var key = "news_" + this.props.news.id;

        if(this.state.imgUrl != ""){

        }
        return (

            <Card key={key}  expanded={this.state.opened} onExpandChange={this.handleGetNews} className="mg-news-item" containerStyle={styles.mgCardStyle} >
                <CardHeader
                    titleStyle={styles.mgCardTitle}
                    subtitleStyle={styles.mgCardSubTitle}
                    title={title}
                    subtitle={date}
                    avatar={avatar}
                    actAsExpander={false}
                    showExpandableButton={true}
                    style={this.props.news.read ? styles.Read : styles.noRead}/>

                {this.renderMediaCard()}

                <CardText expandable={true} style={styles.cardText}>
                    {this.state.showLoadingNews ?
                        <CircularProgress style={styles.loadingIcon}/>
                        : null
                    }
                    <div dangerouslySetInnerHTML={{__html: this.state.text}}/>
                    {documents}
                    {this.state.confirmButton}
                </CardText>
            </Card>
        );
    }
}

News.displayName = componentName;

// PropTypes validation
News.propTypes = {};

// default props
News.defaultProps = {};

// contextTypes validation
News.contextTypes = {
    /*
    * Context per il reload delle news
    * */
    realoadNews: PropTypes.func
}

export default News;